export const WHATSAPP_NUMBER = "32474861621";
export const WHATSAPP_MESSAGE =
  "Hallo Vera, ik heb de welzijnscheck ingevuld en ontvang graag mijn gratis welzijnsevaluatie en bodyscan.";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;

export const SOCIALS = {
  website: "https://www.gezondmetvera.be/",
  instagram: "https://www.instagram.com/gezond.met.vera/",
  facebook: "https://www.facebook.com/vera.prive?locale=nl_BE",
  tiktok: "https://www.tiktok.com/@gezondmetvera",
};

export const VERA = {
  name: "Vera Budé",
  brand: "Gezond met Vera",
  role: "Orthomoleculair Therapeut",
  location: "Genk, België",
  photo:
    "https://customer-assets.emergentagent.com/job_energy-score-be/artifacts/pk8dldw2_Ontwerp%20zonder%20titel.png",
};

export const LOGO =
  "https://customer-assets.emergentagent.com/job_energy-score-be/artifacts/25sosrde_achterkant%20%28109%20x%20152%20mm%29.png";

export const HERO_IMAGE =
  "https://images.pexels.com/photos/7113357/pexels-photo-7113357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const CATEGORY_COLORS = {
  "Uitstekend welzijn": "#6B8E6A",
  "Goed welzijn": "#8FA38C",
  "Aandachtspunten aanwezig": "#E3A857",
  "Verhoogde aandacht aanbevolen": "#D98A4E",
  "Professioneel advies aanbevolen": "#C86B5E",
};
